var JabberPropertiesData = /** @class */ (function () {
    function JabberPropertiesData() {
        this.properties = [];
    }
    JabberPropertiesData.prototype.addProperty = function (name, type, text) {
        this.properties.push({ name: name, value: {
                type: type,
                text: text
            } });
    };
    return JabberPropertiesData;
}());
export { JabberPropertiesData };
//# sourceMappingURL=jabber-properties-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/jabber-dto/jabber-properties-data.js
// module id = 904
// module chunks = 14